import { useAuth0 } from "@auth0/auth0-react";
import { Check, ContentCopy, Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, IconButton, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { SidebarContext } from "src/contexts/SidebarContext";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function ClientData() {
  const { clientInfo } = useContext(SidebarContext);

  //States to render or not clientInfo in input fields
  const [showClientId, setShowClientId] = useState<Boolean>(false);
  const [showClientSecret, setShowClientSecret] = useState<Boolean>(false);

  //States to copy clientId and clientSecret
  const [isCopiedId, setIsCopiedId] = useState<Boolean>(false);
  const [isCopiedSecret, setIsCopiedSecret] = useState<Boolean>(false);

  //Functions to render or not render clientId and clientSecret when users clicks on the visibility button
  // const handleToggleClientId = () => {
  //   setShowClientId(!showClientId);
  // };

  const handleToggleClientSecret = () => {
    setShowClientSecret(!showClientSecret);
  };

  //Funciton to copy clientId
  const handleCopyClientId = async () => {
    try {
      if (!clientInfo?.clientId) throw new Error("No text to copy");
      await navigator.clipboard.writeText(clientInfo.clientId);
      setIsCopiedId(true);
      setTimeout(() => setIsCopiedId(false), 1000);
    } catch (err) {
      console.error("Error copying text:", err);
    }
  };

  //Funciton to copy clientSecret
  const handleCopyClientSecret = async () => {
    try {
      if (!clientInfo?.clientId) throw new Error("No text to copy");
      await navigator.clipboard.writeText(clientInfo.clientSecret);
      setIsCopiedSecret(true);
      setTimeout(() => setIsCopiedSecret(false), 1000);
    } catch (err) {
      console.error("Error copying text:", err);
    }
  };

  return (
    <Grid item xs={12} md={6} sm={8} lg={6} sx={{ display: "flex", flexDirection: "column", pt: { lg: 0, xs: 2 } }}>
      <Card
        sx={{
          border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
          boxShadow: "none",
          borderRadius: 0.5,
          backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
            p: 1.5,
          }}
        >
          <Typography variant="h4" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}>
            For developers
          </Typography>
        </Box>
        <CardContent>
          <Typography variant="h5" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} pb={1}>
            Getting started with the API
          </Typography>
          <Typography variant="body2" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} pb={1}>
            Check out our{" "}
            <a
              href={`${process.env.REACT_APP_API_DOCUMENTATION}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white", textDecoration: "underline", fontWeight: "bold" }}
            >
              API documentation.
            </a>
          </Typography>
          <Typography variant="body2" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} pb={3}>
            You’ll need your Client ID and Client Secret below:
          </Typography>

          {/* Client ID */}
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" pb={1.5}>
            <Typography variant="h4" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}>
              Client ID
            </Typography>

            <Button variant="text" onClick={handleCopyClientId} sx={{ justifyContent: "end", p: 0, color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
              {isCopiedId ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
            </Button>
          </Box>
          <OutlinedInput
            size="small"
            fullWidth
            // type={showClientId ? "text" : "password"}
            type="text"
            value={clientInfo?.clientId || ""}
            // endAdornment={
            //   <InputAdornment position="end">
            //     <IconButton onClick={handleToggleClientId} edge="end" sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
            //       {showClientId ? <VisibilityOff /> : <Visibility />}
            //     </IconButton>
            //   </InputAdornment>
            // }
            readOnly
            sx={{
              color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              fontFamily: "Roboto, arial",
              backgroundColor: "transparent",
              border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[100]}`,
            }}
          />

          {/* Client Secret */}
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" pt={2} pb={1.5}>
            <Typography variant="h4" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}>
              Client Secret
            </Typography>
            <Button variant="text" onClick={handleCopyClientSecret} sx={{ justifyContent: "end", p: 0, color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
              {isCopiedSecret ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
            </Button>
          </Box>
          <OutlinedInput
            size="small"
            fullWidth
            type={showClientSecret ? "text" : "password"}
            value={clientInfo?.clientSecret || ""}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={handleToggleClientSecret} edge="end" sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
                  {showClientSecret ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            readOnly
            sx={{
              color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              fontFamily: "Roboto, arial",
              backgroundColor: "transparent",
              border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[100]}`,
            }}
          />
        </CardContent>
      </Card>
    </Grid>
  );
}

export default ClientData;
